import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "..";
import { IAddAccountFlow } from "../../resources/interfaces";
import { ACCOUNT_TYPES, COMPANY_TYPES, CURRENCIES, PAYMENT_CYCLES } from "../../resources/enums";
import { BLANK_CUSTOMER_DATA } from "../../components/models/customer/Customer";

interface IInitialState {
    ADD_ACCOUNT: IAddAccountFlow;
}

const initialState: IInitialState = {
    ADD_ACCOUNT: {
        is_completed: false,
        current_step: 0,
        data: {
            customer_details: BLANK_CUSTOMER_DATA,
            account_details: {
                type: ACCOUNT_TYPES.SUSU,
                currency: CURRENCIES.GHS,
                id: "",
                rate: 0,
                payment_cycle: PAYMENT_CYCLES.DAILY,
                purpose: ""
            }
        }
    }
};

const appFlowsSlice = createSlice({
    name: "appFlows",
    initialState,
    reducers: {
        UPDATE_ADD_ACCOUNT: (state, action: PayloadAction<Partial<IAddAccountFlow>>) => {
            state.ADD_ACCOUNT = {
                ...state.ADD_ACCOUNT,
                ...action.payload
            };
            return state;
        },
        RESET_ADD_ACCOUNT: (state) => {
            state.ADD_ACCOUNT = initialState.ADD_ACCOUNT;
            return state;
        },
    }
});

export const getAddAccount = (state: RootState): IAddAccountFlow => {
    return state.appFlows.ADD_ACCOUNT;
}

export const isAddAccountCompleted = (state: RootState): boolean => {
    return !!state.appFlows.ADD_ACCOUNT?.is_completed;
}

export const getAddAccountStep = (state: RootState): number => {
    return state.appFlows.ADD_ACCOUNT?.current_step;
}


export const { UPDATE_ADD_ACCOUNT, RESET_ADD_ACCOUNT } = appFlowsSlice.actions;
export default appFlowsSlice.reducer;